import { Injectable } from "@angular/core";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  PRIMITIVE,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
} from "shared/provider-webworker";

import { Subject } from "rxjs";
import { TradeQueryRequestPromiseService } from "./TradeQueryRequestPromiseService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { CHANNEL_TRADE_QUERY_REQUEST } from "../ITradeQueryRequestService";
import { FindDealsDealAdapter } from "../../mediator/adapter/FindDealsDealAdapter";
import { DealPrivatizationService } from "../../model/privatization/DealPrivatizationService";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { QueryResponse } from "./OrderQueryRequestPrimaryService";

@Injectable()
export class TradeQueryRequestPrimaryService {
  protected ready: Promise<void>;
  protected broker: ServiceMessageBroker;

  constructor(
    private worker: CubiqWorker,
    protected factory: ServiceMessageBrokerFactory,
    private dataAdapter: FindDealsDealAdapter,
    private privatizationService: DealPrivatizationService,
  ) {
    // this.broker =
    //     factory.createMessageBroker(CHANNEL_TRADE_QUERY_REQUEST, true, true);

    // this.broker.registerMethod(
    //   'request', [ CubiqTS.ENCODABLE(CubiqTS.TradeQueryRequestImpl) ],
    //   this.request.bind(this),
    //   CubiqTS.ENCODABLE(CubiqTS.StandardReportImpl),
    // );

    // this.broker.registerMethod(
    //   'requestAdaptedTradeData', [ CubiqTS.ENCODABLE(CubiqTS.TradeQueryRequestImpl) ],
    //   this.requestAdaptedTradeData.bind(this),
    //   PRIMITIVE,
    // );

    this.ready = new Promise<void>((res, rej) => {
      res();
    });
  }

  public request(tradeQuery: CubiqTS.TradeQueryRequest): Promise<CubiqTS.StandardReport> {
    return new Promise<CubiqTS.StandardReport>((resolve, reject) => {
      Promise.all([this.worker.postServiceRequest(tradeQuery), this.ready]).then(
        (values: any[]) => {
          logger.out.info("TradeQueryRequest: response received");
          let value = values[0];

          resolve(value);
        },
        (reason) => {
          logger.out.error("TradeQueryRequest: query failed");
          reject(reason);
        },
      );
    });
  }

  public requestParentOrderIds(tradeQuery: CubiqTS.TradeQueryRequest): Promise<QueryResponse> {
    return new Promise<QueryResponse>((resolve, reject) => {
      Promise.all([this.worker.postServiceRequest(tradeQuery), this.ready]).then(
        (searchResults: any[]) => {
          logger.out.info("TradeQueryRequest: response received");
          let results: QueryResponse = new QueryResponse();

          if (Array.isArray(searchResults)) {
            let value = searchResults[0];
            if (value instanceof CubiqTS.ErrorsImpl) {
              results = this.handleFindDealsErrors(tradeQuery, value, results);
            } else {
              // parse order ids
            }
          }

          resolve(results);
        },
        (reason) => {
          reject(reason);
        },
      );
    });
  }

  public requestTradeData(tradeQuery: CubiqTS.TradeQueryRequest): Promise<QueryResponse> {
    return new Promise<QueryResponse>((resolve, reject) => {
      Promise.all([this.worker.postServiceRequest(tradeQuery), this.ready]).then(
        (values: any[]) => {
          let results: QueryResponse = new QueryResponse();

          if (Array.isArray(values)) {
            let value = values[0];
            if (value instanceof CubiqTS.ErrorsImpl) {
              results = this.handleFindDealsErrors(tradeQuery, value, results);
            } else {
              let adaptedReport: CubiqTS.StandardReport = new CubiqTS.StandardReportImpl();

              results.found = value.results.map((tradeData: CubiqTS.DealImpl) => {
                tradeData = this.privatizationService.checkPrivatization(tradeData);
                // return this.dataAdapter.adaptRow(tradeData);
                return tradeData;
              });
            }
          }

          resolve(results);
        },
        (reason) => {
          reject(reason);
        },
      );
    });
  }

  handleFindDealsErrors(
    query: CubiqTS.TradeQueryRequest,
    value: CubiqTS.ErrorsImpl,
    response: QueryResponse,
  ): QueryResponse {
    logger.out.error(
      `${this.constructor.name}: failed to find trade based on critiera %O (%O)`,
      query,
      value,
    );

    response.errors = value;
    response.isError = true;

    return response;
  }
}
